export const appName = 'Price Scenarios Finder';
